// L'onglet « Ceux qui en parlent » de la fiche d'une personnalité (15 octobre 2026).
// Jamais de genre deviné : « ce qui s’en dit », « son regard », jamais « d’elle ».
// Jamais un nombre de mentions : la part de chaque groupe, en %.
export default {
  pct: '{n} %',
  autres: 'Autres',
  groupes: 'Les groupes',
  quand: { aujourdhui: 'aujourd’hui', le: 'le {jour}' },
  graphe: {
    titre: 'Qui fait la conversation, jour par jour',
    legende: 'la part de chaque groupe dans ce qui s’en dit, sur {n} jour | la part de chaque groupe dans ce qui s’en dit, sur {n} jours',
    aujourdhui: 'aujourd’hui',
    aria: 'La part de chaque groupe dans la conversation, sur {n} jour ; {quand} : {parts}. | La part de chaque groupe dans la conversation, sur {n} jours ; {quand} : {parts}.',
  },
  carte: {
    ecart: '{n} pts sur 7 jours',
    courbe: 'sa part, sur {n} jour | sa part, sur {n} jours',
    courbeAria: 'Sa part de la conversation sur {n} jour, {part} {quand} | Sa part de la conversation sur {n} jours, {part} {quand}',
  },
  bascule: {
    camp: 'Change de camp : {avant} la semaine d’avant, {apres} {quand}',
    poidsPlus: 'Pèse soudain plus lourd dans la conversation',
    poidsMoins: 'Pèse soudain moins lourd dans la conversation',
  },
  sens: {
    regard: 'son regard',
    maintenant: '{n} {quand}',
    avant: '{n} la semaine d’avant (le trait gris)',
  },
  electeurs: {
    titre: 'Et ses électeurs ?',
    texte: 'Ceux qui en parlent ne sont pas ceux qui votent. Quand cette personnalité est candidate à une élection que vous suivez, ses électeurs apparaissent ici, et on peut leur parler.',
    // Quand elle l'est (16 octobre 2026).
    cherche: 'On cherche si cette personnalité est candidate à une élection que vous suivez…',
    candidat: 'Ses électeurs : {election}',
    distincts: 'Ceux qui en parlent ne sont pas ceux qui votent : voici d’où viennent ses électeurs à la dernière vague, segment par segment.',
    projectionPct: 'Projection {n} ({bas} ~ {haut})',
    projectionSieges: 'Projection {n} sièges ({bas} ~ {haut})',
    voirElection: 'Voir l’élection',
  },
  // Sa fiche complète, dans le panneau latéral (16 octobre 2026).
  fiche: {
    ouvrir: 'Voir la fiche de {nom}',
    titre: '{nom}, « {groupe} »',
  },
  chargement: 'Chargement de ceux qui en parlent…',
  vide: 'Les groupes de ceux qui en parlent se dessinent après quelques jours d’écoute',
  // Parler à une personne du groupe (15 octobre 2026).
  parler: {
    bouton: 'Parler à {nom}',
    origine: '« {groupe} », parmi ceux qui parlent de {qui}',
    q1: 'Que pensez-vous de {qui} en ce moment ?',
    q2: 'Qu’est-ce qui vous ferait changer d’avis sur {qui} ?',
    q3: 'Où en parlez-vous, et avec qui ?',
    bientot: 'Une personne de ce groupe à qui parler se dessine à la prochaine écoute.',
  },
}
